import React from 'react';
import { Box, Text, TransactionsNotFoundIcon } from '@common-fe/common-fe';

import theme from '@/styles/theme';

interface Props {
  title: string;
  boxStyle?: React.CSSProperties;
  isDescriptionHidden?: boolean;
}

export const EmptyTransactionsListPlaceholder: React.FC<Props> = ({
  title,
  boxStyle,
  isDescriptionHidden,
}) => (
  <Box data-testid="TransactionsNotFound" pad={{ top: 'spacing32' }} align="center" style={boxStyle}>
    <Box margin={{ bottom: 'spacing24' }}>
      <TransactionsNotFoundIcon />
    </Box>
    <Text
      data-testid="TransactionsNotFound-title"
      margin={{ bottom: 'spacing12' }}
      size="16px"
      style={{ fontWeight: 700 }}
      color={theme.colors.textTitle}
    >
      There are no {title} yet
    </Text>
    {isDescriptionHidden ? null : (
      <Text color={theme.colors.textBody} size="16px">
        {title} will be added to this list as soon as you make your first spending.
      </Text>
    )}
  </Box>
);
